import React from 'react';
import PropTypes from 'prop-types';
import { GetValuesRender } from './commonViews';

const SettlementView = props => {
    const { data } = props;
    //console.log(data, "consoling dataaaaaaaaaaaa");
    const { accountDetail, accountDetails, narrationConfig, customisedReports, ediConfInfoList, odsConfigInfo } = data;



    // Prepare simpleFields
    let simpleFields = (({
        accountDetail,
        accountDetails,
        narrationConfig,
        customisedReports,
        ediConfInfoList,
        ...rest
    }) => rest)(data);
    simpleFields = { ...accountDetail, ...simpleFields, ...odsConfigInfo };

    

    // Function to extract enabled headers
    const extractHeaders = reports => {
        if (!Array.isArray(reports)) {
            console.warn('Expected an array for reports, received:', reports);
            return [];
        }

        return reports.flatMap(
            report =>
                report.configuration
                    ? report.configuration
                        .filter(header => header.isEnable) // Only include enabled headers
                        .map(header => ({ name: header.name })) // Extract name
                    : [] // If configuration is not defined, return an empty array
        );
    };

    // Extract headers for MSR and MTR
    const msrHeaders = extractHeaders(customisedReports?.MSR || []);
    const mtrHeaders = extractHeaders(customisedReports?.MTR || []);

    if (narrationConfig) {
        if (narrationConfig.prefix) {
            simpleFields = { ...simpleFields, ...narrationConfig.prefix };
        }

        if (narrationConfig.interim) {
            simpleFields = { ...simpleFields, ...narrationConfig.interim };
        }

        if (narrationConfig.secondInterim) {
            simpleFields = { ...simpleFields, secondInterimType: narrationConfig.secondInterim.interimType };
        }

        if (narrationConfig.suffix) {
            simpleFields = { ...simpleFields, ...narrationConfig.suffix };
        }
    }
    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">Settlement Section Data</h1>
                <div className="form-section">
                    <GetValuesRender data={simpleFields} />
                </div>
                <div className={'settlements-checker-container'}>
                    <h3>Bank Accounts</h3>
                    {renderAccounts(accountDetails)}
                </div>
                <div className={'settlements-checker-container'}>
                    {renderEDIs(ediConfInfoList)}
                </div>

                <div className={'msr-mtr-container'}>
                    {renderMSRReport(msrHeaders)}
                    {renderMTRReport(mtrHeaders)}
                </div>
            </div>
        </>
    );
};

const renderMSRReport = (msrHeaders) => {
    if (!msrHeaders || msrHeaders.length === 0) {
        return null;
    }
    return (
        <div className={'msr-mtr-inner-container'}>
            <h3>MSR Report</h3>
            <table border="1" cellPadding="5" cellSpacing="0"
                   style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                <tr>
                    <th>Serial No</th>
                    <th>Header Name</th>
                </tr>
                </thead>
                <tbody>
                {msrHeaders.map((header, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{header.name}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}

const renderMTRReport = (mtrHeaders) => {
    if (!mtrHeaders || mtrHeaders.length === 0) {
        return null;
    }
    return (
        <div className={'msr-mtr-inner-container'}>
            <h3>MTR Report</h3>
            <table border="1" cellPadding="5" cellSpacing="0"
                   style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                <tr>
                    <th>Serial No</th>
                    <th>Header Name</th>
                </tr>
                </thead>
                <tbody>
                {mtrHeaders.map((header, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{header.name}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}

const renderAccounts = (data) => {
    return (
        <div>
            {
                data.map((item, index) => (
                    <div className="table-container checker-view" key={`account-${index}`}>
                        <table className="checker-table" border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%' }}>
                            <thead>
                            <tr>
                                <th style={{ fontWeight: 'bold' }}>Account Holder Name</th>
                                <th style={{ fontWeight: 'bold' }}>Account Number</th>
                                <th style={{ fontWeight: 'bold' }}>Account Ownership</th>
                                <th style={{ fontWeight: 'bold' }}>Debit Frequency</th>
                                <th style={{ fontWeight: 'bold' }}>Account Type</th>
                                <th style={{ fontWeight: 'bold' }}>Bank Name</th>
                                <th style={{ fontWeight: 'bold' }}>IFSC Code</th>
                                <th style={{ fontWeight: 'bold' }}>Is Primary</th>
                                <th style={{ fontWeight: 'bold' }}>Status</th>
                                <th style={{ fontWeight: 'bold' }}>Is verified</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{item.accountHolderName}</td>
                                <td>{item.accountNumber}</td>
                                <td>{item.accountOwnership}</td>
                                <td>{item.debitFrequency || '-'}</td>
                                <td>{item.accountType || '-'}</td>
                                <td>{item.bankName}</td>
                                <td>{item.ifscCode}</td>
                                <td>{item.primary ? "Yes" : "No"}</td>
                                <td>{item.status === 1 ? "Active" : "Inactive"}</td>
                                <td>{item.verified ? "Yes" : "No"}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                ))
            }
        </div>
    )
};

const renderEDIs = (data) => {
    if (!data || data.length === 0) {
        return null;
    }
    return (
        <div>
            <h3>Split Settlements</h3>
            {
                data?.map((item, index) => (
                    <div className="table-container checker-view" key={`edi-${index}`}>
                        <table className="checker-table" border="1" cellPadding="5" cellSpacing="0"
                               style={{ width: '100%' }}>
                            <thead>
                            <tr>
                                <th style={{ fontWeight: 'bold' }}>Is EDI Enabled</th>
                                <th style={{ fontWeight: 'bold' }}>Account Number</th>
                                <th style={{ fontWeight: 'bold' }}>Debit Amount</th>
                                <th style={{ fontWeight: 'bold' }}>Debit Frequency</th>
                                <th style={{ fontWeight: 'bold' }}>Monthly Debit Date</th>
                                <th style={{ fontWeight: 'bold' }}>Debit Type</th>
                                <th style={{ fontWeight: 'bold' }}>Settlement Amount Type</th>
                                <th style={{ fontWeight: 'bold' }}>Settlement Frequency</th>
                                <th style={{ fontWeight: 'bold' }}>Settlement Type</th>
                                <th style={{ fontWeight: 'bold' }}>Consent</th>
                                <th style={{ fontWeight: 'bold' }}>Flat Amount</th>
                                <th style={{ fontWeight: 'bold' }}>Total Amount</th>
                                <th style={{ fontWeight: 'bold' }}>Start Date</th>
                                <th style={{ fontWeight: 'bold' }}>End Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{item.ediEnable ? 'Enabled' : 'Disabled'}</td>
                                <td>{item.accountNumber}</td>
                                <td>{item.debitAmountPer}</td>
                                <td>{item.debitFrequency}</td>
                                <td>{item.monthlyDebitDate || '-'}</td>
                                <td>{item.debitType}</td>
                                <td>{item.settlementAmountType}</td>
                                <td>{item.settlementFrequency}</td>
                                <td>{item.settlementType}</td>
                                <td>{item.consent ? 'Accepted' : 'Denied'}</td>
                                <td>{item.flatAmount || '-'}</td>
                                <td>{item.totalAmount || '-'}</td>
                                <td>{item.startDate}</td>
                                <td>{item.endDate}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                ))
            }
        </div>
    );
};

SettlementView.propTypes = {
    data: PropTypes.object.isRequired,
};

export default SettlementView;
